import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import WithImpressions from '../../../WithImpressions';
import { biHelper } from '../../biHelper';
import Certification from './Certification';

export default function Certifications({ certifications, biData }) {
    if (!certifications.length) { return null; }

    const seller_card_about_me_certifications_impression = biHelper({
        ...biData,
        group: 'seller_card_about_me_certifications_impression',
        data: certifications
    });

    return (
        <WithImpressions className="list" value={seller_card_about_me_certifications_impression}>
            <h3><I18n k="user_page_perseus.seller_profile.certifications"/></h3>
            <ul>
                {certifications.map((certification, idx) =>
                    <Certification certification={certification} key={idx}/>)}
            </ul>
        </WithImpressions>
    );
}

Certifications.propTypes = {
    certifications: PropTypes.array,
    biData: PropTypes.object
};

Certifications.defaultProps = {
    certifications: [],
    biData: {}
};
